import { render, staticRenderFns } from "./IconSelector.vue?vue&type=template&id=1e496a69"
import script from "./IconSelector.vue?vue&type=script&lang=js"
export * from "./IconSelector.vue?vue&type=script&lang=js"
import style0 from "./IconSelector.vue?vue&type=style&index=0&id=1e496a69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports